<template>
  <ValidationProvider rules="required" slim v-slot="state">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles lib__tiles--inline">
        <TileRadio :group="fieldId" :item="1" :label="$t('vatInfo.withoutDeclarationDescription')" no-uncheck v-model="selection">
          <template>
            <span v-html="$t('vatInfo.withoutDeclaration')" />
          </template>
        </TileRadio>
        <TileRadio :group="fieldId" :item="0" :label="$t('vatInfo.withDeclarationDescription')" no-uncheck v-model="selection">
          <template>
            <span v-html="$t('vatInfo.withDeclaration')" />
          </template>
        </TileRadio>
        <TileRadio :group="fieldId" :item="2" :label="$t('vatInfo.notSubjectDescription')" no-uncheck v-model="selection">
          <template>
            <span v-html="$t('vatInfo.notSubject')" />
          </template>
        </TileRadio>
      </div>
      <error-message :error="state.errors[0]"></error-message>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Prop, Emit } from 'vue-property-decorator'
import { FreelanceVatInfoSelection } from '@/models'
import FieldBox from '@/components/inputs/Shared/FieldBox'

@Component({
  name: 'freelance-vat-info-selector'
})
export default class FreelanceVatInfoSelector extends FieldBox {
  //#region [Property]
  @Prop({ type: Number, required: false }) public readonly value!: FreelanceVatInfoSelection | null
  //#endregion

  //#region [Computed]
  public get selection(): FreelanceVatInfoSelection | null {
    return this.value
  }

  public set selection(val: FreelanceVatInfoSelection | null) {
    this.change(val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: FreelanceVatInfoSelection | null): FreelanceVatInfoSelection | null {
    return value
  }
  //#endregion
}
</script>